// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:07:34.420Z
// Property: The Palms at Briarwood (ID: 5175251218464768)
// Collections: 27 amenities, 9 floorplans (live), 25 photos, 38 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5175251218464768",
  "property_external_id": "1089883",
  "property_zillow_url": "https://www.zillow.com/apartments/midland-tx/the-palms-at-briarwood/5XhxXh/",
  "property_apartments_url": "https://www.apartments.com/the-palms-at-briarwood-midland-tx/5ndzksq",
  "property_google_business_url": "https://www.google.com/maps/place/Palms+at+Briarwood/data=!4m2!3m1!1s0x0:0x736a660fac22312c?sa=X&ved=2ahUKEwjH5KbLl7mSAxXeATQIHam3I0YQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-palms-at-briarwood",
  "property_name": "The Palms at Briarwood",
  "property_website_url": "https://www.palmsatbriarwood.com",
  "property_domain": "https://www.palmsatbriarwood.com",
  "property_address": "4805 Briarwood Ave",
  "property_full_address": "4805 Briarwood Ave, Midland, TX, 79707",
  "property_address_1": "4805 Briarwood Ave",
  "property_address_2": null,
  "property_address_city": "Midland",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79707",
  "property_address_country": "US",
  "property_address_county": "Midland County",
  "property_neighborhood_address": "Midland & Odessa",
  "property_address_latitude": "32.0277",
  "property_address_longitude": "-102.1524",
  "property_email": "thepalms@weidner.com",
  "property_phone": "4322374842",
  "property_call_tracking_phone": "432-218-3244",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Palms at Briarwood in Midland, TX, where stylish living meets comfort. Choose from one, two, or three-bedroom layouts featuring stainless steel appliances and granite breakfast bars. Enjoy amenities like a coffee station, media room, and off-leash dog park. Your perfect home awaits—check availability or schedule a tour today!",
  "property_long_description": "Welcome to The Palms at Briarwood, Midland, TX's premier apartment community, where modern living meets comfort and convenience. Our thoughtfully designed floor plans include spacious one, two, and three-bedroom apartments, each tailored to fit your lifestyle. Every home is equipped with sleek stainless steel appliances, luxurious granite breakfast bars, and customizable built-in bookshelves and desks for your convenience. \n\nAt The Palms at Briarwood, we believe in more than just providing a home – we create a vibrant community. Enjoy our exceptional amenities designed for relaxation and recreation, including a cozy coffee station to kickstart your mornings, a state-of-the-art media room for movie nights, and a fully equipped fitness center featuring both cardio and weight machines. Our off-leash pet play area and dog park invite you to enjoy quality time with your furry companions.\n\nAdditionally, educators can take advantage of our exclusive MISD and ECISD teacher's discount, making your new home even more affordable. Explore a lifestyle of convenience and camaraderie at The Palms at Briarwood, where you can connect with neighbors and enjoy community gatherings.\n\nReady to elevate your living experience? Find your new home today – browse our availability or schedule a tour to visit our community! Life at The Palms at Briarwood is waiting for you!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-f494-73a7-8f0c-38c5b0547b6d.webp",
  "property_featured_image_media": {
    "alt_text": "Luxurious lounge area with a large stone fireplace and comfortable seating.",
    "public_id": "019d019d-f494-73a7-8f0c-38c5b0547b6d",
    "storage_key": "property/5175251218464768/019d019d-f494-73a7-8f0c-38c5b0547b6d.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "280",
  "property_year_built": "2007",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.28571428571428",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "500-700",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Cats and dogs are welcome (no other pets). Maximum 2 pets per unit. One-time non‑refundable pet fee: $300 per pet. Refundable pet deposit: $300 per pet. Monthly pet rent: $25 per pet. No weight limit, but breed restrictions apply (e.g., Pit Bull, Rottweiler, German Shepherd, Great Dane, Akita, etc.).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://palmsatbriarwood.securecafe.com/onlineleasing/the-palms-at-briarwood/floorplans.aspx",
  "property_resident_portal_url": "https://palmsatbriarwood.securecafe.com/residentservices/the-palms-at-briarwood/userlogin.aspx",
  "property_apply_now_url": "https://palmsatbriarwood.securecafe.com/onlineleasing/the-palms-at-briarwood/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-6c55-768b-aaae-f9521074b599.webp",
  "property_primary_logo_media": {
    "alt_text": "The Palms at Briarwood Apartment Homes logo",
    "public_id": "019d019c-6c55-768b-aaae-f9521074b599",
    "storage_key": "property/5175251218464768/019d019c-6c55-768b-aaae-f9521074b599.webp",
    "width": 190,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-ead2-773a-acf5-a21a40e8bccd.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo.",
    "public_id": "019d019d-ead2-773a-acf5-a21a40e8bccd",
    "storage_key": "property/5175251218464768/019d019d-ead2-773a-acf5-a21a40e8bccd.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019e-01d5-74ad-bbb7-8a49eb1915d5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Palms at Briarwood Apartment Homes logo.",
    "public_id": "019d019e-01d5-74ad-bbb7-8a49eb1915d5",
    "storage_key": "property/5175251218464768/019d019e-01d5-74ad-bbb7-8a49eb1915d5.webp",
    "width": 190,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019e-0b08-71eb-ae0f-6db73ff4b16d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Palms at Briarwood Apartment Homes logo",
    "public_id": "019d019e-0b08-71eb-ae0f-6db73ff4b16d",
    "storage_key": "property/5175251218464768/019d019e-0b08-71eb-ae0f-6db73ff4b16d.webp",
    "width": 190,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1333",
  "property_sqft_min": "736",
  "property_sqft_max": "1333",
  "property_price_range": "1250 - 2585",
  "property_price_min": "1250",
  "property_price_max": "2585",
  "property_available_units": 22,
  "property_facebook_url": "https://www.facebook.com/ThePalmsAtBriarwoodApartments",
  "property_instagram_url": "https://www.instagram.com/thepalmsatbriarwoodapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJx5fow1rZ-4YRLDEirA9manM",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Palms at Briarwood",
  "property_home_romance_title": "Embrace Comfort and Community in Your New Home Today",
  "property_home_amenities_blurb": "Welcome to The Palms at Briarwood in Midland, TX—your sanctuary of comfort and style. Choose from spacious one, two, or three-bedroom apartments featuring modern kitchens with stainless steel appliances, granite countertops, and walk-in closets. Enjoy luxurious amenities like a refreshing pool, fitness center, and off-leash dog park, making every day extraordinary.",
  "property_home_floorplans_blurb": "At The Palms at Briarwood in Midland, TX, we offer a spectrum of stylish living options, from cozy one-bedroom retreats to spacious three-bedroom havens. Each floor plan is tailored for comfort and convenience. Browse our available apartment homes today and find the perfect layout that fits your lifestyle!",
  "property_home_gallery_blurb": "Welcome to The Palms at Briarwood, where modern comfort meets vibrant community living in Midland, TX. Choose from spacious one, two, or three-bedroom floor plans, each featuring upscale amenities like stainless steel appliances, electric fireplaces, and walk-in closets. With a pet play area, fitness center, and inviting clubhouse, this is home. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Midland, TX, The Palms at Briarwood offers a vibrant community surrounded by local gems. Whether you prefer a cozy one-bedroom or a spacious three-bedroom layout, you'll find the perfect home here. Dive into the neighborhood and uncover exciting attractions just moments away!",
  "property_home_reviews_blurb": "At The Palms at Briarwood in Midland, TX, residents cherish the friendly atmosphere and well-kept community. One happy tenant raves, “The Palms is the best in Midland...secure living at its finest.” With spacious floor plans and a welcoming staff, your ideal home awaits—where comfort meets convenience!",
  "property_neighborhood_blurb": "Nestled in the heart of Midland, The Palms at Briarwood offers more than just exceptional one, two, and three-bedroom apartments. Embrace an active lifestyle with nearby Orangetheory Fitness and the Midland YMCA, or unwind at the serene I-20 Wildlife Preserve. Your vibrant community awaits—see what’s around you!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Palms at Briarwood in Midland, TX, your tranquil oasis awaits. Choose from spacious one, two, or three-bedroom apartments, complete with stainless steel appliances and granite breakfast bars. Enjoy our inviting coffee station, vibrant media room, and off-leash pet play area. Elevate your lifestyle today—embrace the comfort and convenience!",
  "property_applynow_blurb": "At The Palms at Briarwood in Midland, TX, modern living meets comfort. Choose from stylish one, two, or three-bedroom apartments featuring stainless steel appliances and granite breakfast bars. Enjoy community perks like a coffee station, media room, and an off-leash dog park. Apply now and secure your perfect home today!",
  "property_contactus_blurb": "At The Palms at Briarwood in Midland, TX, our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Ready to find your ideal living space? Have questions? Contact our leasing team today to learn more about making The Palms your new home!",
  "property_faqs_blurb": "At The Palms at Briarwood in Midland, TX, we offer an array of floor plans, including cozy one-bedroom, spacious two-bedroom, and expansive three-bedroom options. Have questions? Our FAQs page is the perfect place to uncover everything you need to know about our vibrant community. Dive in and learn more!",
  "property_floorplans_blurb": "Embrace the lifestyle you deserve at The Palms at Briarwood in Midland, TX. Our thoughtfully designed floor plans—a blend of one, two, and three-bedroom options—offer spacious comfort and modern conveniences. Unveil the perfect backdrop for your life; browse our available apartments and find your ideal fit today!",
  "property_gallery_blurb": "At The Palms at Briarwood in Midland, TX, comfort meets style with spacious one-, two-, and three-bedroom floor plans. Picture yourself enjoying our inviting media room, vibrant off-leash dog park, and a sleek kitchen boasting stainless steel appliances and a granite breakfast bar. Your ideal lifestyle awaits!",
  "property_interactivemap_blurb": "Welcome to The Palms at Briarwood in Midland, TX, where your ideal living space awaits! Choose from one, two, or three-bedroom floor plans featuring modern comforts like stainless steel appliances, built-in bookshelves, and a dining room. Enjoy community perks like a media room and dog park. Start your journey with our interactive community map today!",
  "property_pets_blurb": "Nestled in the heart of Midland, TX, The Palms at Briarwood offers a serene retreat for you and your furry friends. With stylish apartments and a pet-friendly atmosphere, you'll enjoy a vibrant community that feels like home. Embrace a lifestyle where comfort meets convenience in every paw-step you take.",
  "property_referafriend_blurb": "At The Palms at Briarwood in Midland, TX, the lifestyle you’ve always desired is just a referral away. With spacious one, two, and three-bedroom floor plans, your ideal home is waiting. Great friends make great neighbors—bring someone special to our community today! Experience the joy of living together!",
  "property_residentaccess_blurb": "At The Palms at Briarwood in Midland, TX, our diverse floor plans—one, two, and three-bedroom options—cater to your unique lifestyle. Need assistance? Access your resident portal to effortlessly pay rent, schedule maintenance, and enjoy a stress-free living experience. Your oasis awaits just a click away!",
  "property_reviews_blurb": "At The Palms at Briarwood in Midland, TX, residents rave about our immaculate grounds and welcoming staff. One satisfied resident shares, \"The Palms is the best in Midland... My mom and I knew this was the one.\" Experience a community where comfort and care come together seamlessly.",
  "property_created_at": "1752256301079",
  "property_scheduletour_blurb": "At The Palms at Briarwood in Midland, TX, your ideal living space awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans that cater to every lifestyle. Ready to envision your new home? Schedule a tour today and hear firsthand what our residents love about our vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out! At The Palms at Briarwood in Midland, TX, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom havens—offer the perfect backdrop for your lifestyle. Look forward to a member of our team connecting with you soon to assist with your next step!",
  "property_virtualtours_blurb": "Experience modern living at The Palms at Briarwood in Midland, TX, where our thoughtfully designed one, two, and three-bedroom apartments await you. Step inside and envision your new lifestyle—take a virtual tour today to explore your future home and vibrant community. Your doorstep to comfort is just a click away!",
  "property_copyright": "2025 All Rights Reserved. The Palms at Briarwood",
  "property_seo_title_home": "The Palms at Briarwood | Apartments in Midland, TX",
  "property_seo_description_home": "Welcome to The Palms at Briarwood in Midland, TX, where modern living meets thoughtful design. Choose from our diverse floor plans—one, two, or three-bedroom options—each featuring stylish stainless steel appliances and elegant granite breakfast bars. Unwind in our media room, fuel up at the coffee station, or enjoy outdoor fun at our off-leash dog park. With amenities like bike storage and fitness opportunities including cardio and weight machines, your lifestyle thrives here. Plus, we offer exclusive discounts for MISD & ECISD teachers. Your dream home awaits—find it today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Midland, TX",
  "property_seo_description_floorplans": "Unlock the door to your dream living space at The Palms at Briarwood in Midland, TX! With thoughtfully designed one, two, and three-bedroom floor plans, we offer a variety of options tailored for your lifestyle. Dive into our unique layouts and envision your ideal home - the perfect blend of comfort and style awaits. Browse our available apartment homes today and take the first step toward elevated living!",
  "property_seo_title_amenities": "Amenities | Midland, TX Apartments for Rent",
  "property_seo_description_amenities": "Unwind at The Palms at Briarwood in Midland, TX, where modern living meets convenience. Choose from thoughtfully designed one, two, and three-bedroom apartments featuring stainless steel appliances and granite breakfast bars. Elevate your lifestyle with our vibrant amenities, including a cozy coffee station, media room, and off-leash dog park. Fitness enthusiasts will thrive with our state-of-the-art cardio and weight machines. Plus, teachers can take advantage of exclusive discounts! Dive into our community and see how we can elevate your living experience.",
  "property_seo_title_gallery": "Gallery | Apartments in Midland, TX",
  "property_seo_description_gallery": "Capture your dream lifestyle at The Palms at Briarwood in Midland, TX. Browse our stunning photo gallery showcasing spacious one, two, and three-bedroom apartments featuring elegant granite breakfast bars and stainless steel appliances. Enjoy premium amenities including a cozy coffee station, a welcoming media room, and an off-leash dog park tailored for your furry friends. With dedicated spaces for fitness and relaxation, plus exclusive discounts for MISD and ECISD teachers, it’s all here. Picture yourself living in the vibrant community you’ve always wanted!",
  "property_seo_title_virtualtours": "Virtual Tours | The Palms at Briarwood Apartments",
  "property_seo_description_virtualtours": "Step into luxury living at The Palms at Briarwood in Midland, TX. Our diverse floor plans—one, two, and three bedrooms—offer the perfect blend of style and comfort. From spacious layouts to modern amenities, each apartment is designed to elevate your lifestyle. Ready to envision your new home? Take a virtual tour of our vibrant community and see what makes us the ideal choice for your next chapter!",
  "property_seo_title_interactivemap": "Interactive Map | The Palms at Briarwood Apartments",
  "property_seo_description_interactivemap": "Find your perfect sanctuary at The Palms at Briarwood in Midland, TX. With thoughtfully designed layouts featuring one, two, and three-bedroom floor plans, our community caters to every lifestyle. Enjoy on-site amenities like a cozy coffee station, a modern media room, and an off-leash dog park, while residents benefit from stainless steel appliances and elegant granite breakfast bars. Teachers from MISD & ECISD receive exclusive discounts! Navigate your new home effortlessly with our interactive community map—where your next adventure begins!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Midland, TX",
  "property_seo_description_neighborhood": "Nestled in the heart of Midland, TX, The Palms at Briarwood is more than just a place to live—it's a vibrant community surrounded by local gems. Uncover charming eateries, lush parks, and entertainment hotspots just around the corner. Ready to find your perfect neighborhood? Check out the delights waiting just outside your door!",
  "property_seo_title_contact": "Contact Us | The Palms at Briarwood",
  "property_seo_description_contact": "Experience modern living at The Palms at Briarwood in Midland, TX, where comfort meets convenience. Choose from stylish one, two, and three-bedroom floor plans designed to fit your lifestyle. Whether you’re looking for a cozy retreat or a spacious home, we have options for you. Ready to learn more? Reach out to our leasing team today with any questions you may have!",
  "property_seo_title_faqs": "FAQs | Apartments in Midland, TX",
  "property_seo_description_faqs": "Uncover the unique lifestyle at The Palms at Briarwood in Midland, TX, where modern comfort meets community spirit. Our range of spacious floor plans, from one to three bedrooms, caters to every need, while exceptional amenities like a cozy coffee station, state-of-the-art media room, and an inviting pet-friendly dog park enhance your living experience. With exclusive teacher discounts and stylish features like stainless steel appliances and built-in bookshelves, your dream home awaits. Have questions? Our FAQs page is here to provide the insights you need!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Midland, TX",
  "property_seo_description_reviews": "Experience the charm of The Palms at Briarwood in Midland, TX, where modern living meets a vibrant community! Immerse yourself in thoughtfully designed one, two, and three-bedroom apartments featuring stylish granite breakfast bars and stainless steel appliances. Enjoy amenities like our inviting coffee station, media room, and a fun off-leash pet play area. Join the supportive community and see what our residents love about their homes. Their stories await—check out the resident reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Midland, TX",
  "property_seo_description_applynow": "Unlock a vibrant lifestyle at The Palms at Briarwood in Midland, TX. Choose from stylish one, two, or three-bedroom floor plans, each featuring stainless steel appliances, granite breakfast bars, and built-in bookshelves. Enjoy our inviting amenities including a cozy coffee station, a state-of-the-art media room, and an off-leash dog park for your furry friends. Plus, our fitness center is equipped with cardio and weight machines to meet your active needs. With exclusive discounts for MISD & ECISD teachers, it’s time to call this community home. Ready to take the leap? Secure your new apartment and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Palms at Briarwood",
  "property_seo_description_residentaccess": "\"Welcome to your home base at The Palms at Briarwood in Midland, TX. Easily access our resident portal to streamline rent payments, request maintenance, and connect with your community effortlessly. Your comfortable living experience starts here!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Palms at Briarwood",
  "property_seo_description_referafriend": "\"Spread the word about The Palms at Briarwood in Midland, TX! Refer a friend today and help build a vibrant community where great friends become great neighbors. Your next adventure awaits!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Palms at Briarwood",
  "property_seo_description_scheduletour": "Experience the serene lifestyle of The Palms at Briarwood in Midland, TX, where modern comfort meets vibrant community living. Uncover your future home and envision your life in our stunning apartments. Schedule a tour today to see what makes us special!",
  "property_seo_title_privacy": "Privacy Policy | The Palms at Briarwood",
  "property_seo_description_privacy": "\"At The Palms at Briarwood, your peace of mind matters. Our comprehensive privacy policy outlines how we protect your personal information. Trust us to keep your data safe while you enjoy the comforts of Midland, TX living. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | The Palms at Briarwood",
  "property_seo_description_accessibility": "\"At The Palms at Briarwood in Midland, TX, we’re committed to ensuring everyone feels at home online. Our Accessibility Statement reflects our dedication to digital inclusion, making your apartment search seamless and enjoyable. Join our inclusive community today!\"",
  "property_seo_title_sitemap": "Sitemap | The Palms at Briarwood",
  "property_seo_description_sitemap": "Unlock the full potential of The Palms at Briarwood! Navigate your way through our comprehensive sitemap to explore every feature and amenity our vibrant Midland, TX community has to offer. Plan your perfect living experience today!",
  "property_seo_title_thankyou": "Thank You | The Palms at Briarwood",
  "property_seo_description_thankyou": "Thank you for reaching out to The Palms at Briarwood in Midland, TX! Your inquiry is important to us, and a friendly team member will connect with you soon to help you find your perfect apartment oasis. Get ready to embrace a vibrant community and resort-style living!",
  "property_seo_title_pets": "Pet Policy | Apartments in Midland, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293659146",
  "amenities": [
    {
      "id": "ec_11672f3020f50273b94ca971",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Sparkling Resort-Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba5f90147105fa7e4e65005a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center with Free Wifi Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4efb233e41b4178d19f5a9c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25df3d0af72d56c85f1da2fb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9779a0f9f003a5e71e6f4c45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a1243712ae5da2bddc6d5d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00a4a9b4adc6b6238be87327",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Propane and Charcoal Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78684ca43ae097100587304f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Off-Leash Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2991c74947cfd8a98d60464",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27019a7b70bf78fe011fdbb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6abb0739842a0c32d5afd75",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Year-Round Spa/Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3ce31670cd8f710bf6654f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49604f10a932f479483bb6f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Weight Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5968f05e865bfa3e5e38d266",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "MISD & ECISD Teacher's Discount",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13b304f63095a09bd9c43bc0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b01a37afb9f5d54b4cdcdc5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1d6cbc7c7c4cf43286ff7e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4b81212ab895ebf1fb2abf4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7276123a1e512abc1efd896c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e3ece86f8bc211360878084",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0b4c5f60415b0e62e7092de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Electric Fireplace in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1797bbcbbfb526114a320767",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8cabc463d7503da1d8b789bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c08ff73b732c3a77d3a41c2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Built-In Bookshelves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea62d4deef85d2213b131c38",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Built-In Office/Desk",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8546b156eace6da3fb6e75ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06d8df06ae905df209534f64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "external_id": "false",
      "title": "Walk-In Closets in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_3e0b28e9a014600c42f6bcbd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-2e35-75e9-8cc3-22d79c4898a3.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, microwave, stove, and dishwasher in a kitchen with light wood cabinets.",
        "public_id": "01a0d1ce-2e35-75e9-8cc3-22d79c4898a3",
        "storage_key": "property/5175251218464768/01a0d1ce-2e35-75e9-8cc3-22d79c4898a3.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring stainless steel appliances, light wood cabinetry, and granite countertops, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Stainless steel refrigerator, microwave, stove, and dishwasher in a kitchen with light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (27).jpg"
    },
    {
      "id": "ec_1a7c010ea003906528d36e43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-4b23-71a0-ab6d-19d0a324bd00.webp",
      "image_media": {
        "alt_text": "Lounge area with comfortable seating and a large television.",
        "public_id": "01a0d1ce-4b23-71a0-ab6d-19d0a324bd00",
        "storage_key": "property/5175251218464768/01a0d1ce-4b23-71a0-ab6d-19d0a324bd00.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, perfect for gatherings or quiet enjoyment.",
      "link": "false",
      "alt_text": "Lounge area with comfortable seating and a large television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (42).jpg"
    },
    {
      "id": "ec_24f9ba2d099ab9031e6f1106",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-4ab9-7099-b222-d41cbeda2882.webp",
      "image_media": {
        "alt_text": "Cozy living room with sofa, coffee table, and decorative shelves.",
        "public_id": "01a0d1ce-4ab9-7099-b222-d41cbeda2882",
        "storage_key": "property/5175251218464768/01a0d1ce-4ab9-7099-b222-d41cbeda2882.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Relax in this inviting living space, featuring comfortable seating and elegant shelving for your personal touch.",
      "link": "false",
      "alt_text": "Cozy living room with sofa, coffee table, and decorative shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (40).jpg"
    },
    {
      "id": "ec_496790b1d59368c883710d86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-4d7d-75ac-8b19-f969d589cff2.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "01a0d1ce-4d7d-75ac-8b19-f969d589cff2",
        "storage_key": "property/5175251218464768/01a0d1ce-4d7d-75ac-8b19-f969d589cff2.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern vanity with a large mirror, a clean toilet, and a bathtub with a decorative shower curtain. The room is well-lit and includes ample storage space.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (25).JPG"
    },
    {
      "id": "ec_5b4c5a48ab52c1a4fefec907",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-4ea8-75aa-ba3d-5e6b2614713b.webp",
      "image_media": {
        "alt_text": "Luxurious community lounge area with two sofas, a fireplace, and a coffee table.",
        "public_id": "01a0d1ce-4ea8-75aa-ba3d-5e6b2614713b",
        "storage_key": "property/5175251218464768/01a0d1ce-4ea8-75aa-ba3d-5e6b2614713b.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace and comfortable seating for all residents.",
      "link": "false",
      "alt_text": "Luxurious community lounge area with two sofas, a fireplace, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (35).jpg"
    },
    {
      "id": "ec_db685bb703e85eaaf21ca0d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-6678-72ae-b27f-110d88a5678b.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace and plush sofa.",
        "public_id": "01a0d1ce-6678-72ae-b27f-110d88a5678b",
        "storage_key": "property/5175251218464768/01a0d1ce-6678-72ae-b27f-110d88a5678b.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room, featuring a beautiful fireplace, comfortable sofa, and elegant decor.",
      "link": "false",
      "alt_text": "Cozy living room with a fireplace and plush sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (33).jpg"
    },
    {
      "id": "ec_127aee1fa12956dd76c4fa35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-8b90-737e-b086-e9c0bb58737f.webp",
      "image_media": {
        "alt_text": "Living room and dining area with bar seating.",
        "public_id": "01a0d1ce-8b90-737e-b086-e9c0bb58737f",
        "storage_key": "property/5175251218464768/01a0d1ce-8b90-737e-b086-e9c0bb58737f.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious living room with comfortable seating, a dining area, and a breakfast bar with stools. The apartment features large windows with blinds and elegant curtains.",
      "link": "false",
      "alt_text": "Living room and dining area with bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (23).jpg"
    },
    {
      "id": "ec_e6ecc856a6e823e842c8e906",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-8ad4-7650-85a8-44eb26093359.webp",
      "image_media": {
        "alt_text": "Dining area with a table set for four and floor-to-ceiling windows.",
        "public_id": "01a0d1ce-8ad4-7650-85a8-44eb26093359",
        "storage_key": "property/5175251218464768/01a0d1ce-8ad4-7650-85a8-44eb26093359.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Enjoy meals in this elegant dining area, perfect for intimate gatherings or formal dinners. Features ample natural light from large windows.",
      "link": "false",
      "alt_text": "Dining area with a table set for four and floor-to-ceiling windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (29).JPG"
    },
    {
      "id": "ec_88d3feb9762f2705d3fa5009",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-9501-7751-b7bb-a4092386252e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a doorway to the bathroom.",
        "public_id": "01a0d1ce-9501-7751-b7bb-a4092386252e",
        "storage_key": "property/5175251218464768/01a0d1ce-9501-7751-b7bb-a4092386252e.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious and inviting bedroom featuring a plush queen-size bed, elegant nightstands, and a private ensuite bathroom. Perfect for relaxation and comfort.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a doorway to the bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (32).JPG"
    },
    {
      "id": "ec_4c65ed9d3a7505207a6b7ee6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-8bf4-725b-ba79-00ba40c5db25.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-size bed, plush bedding, and a window with blinds.",
        "public_id": "01a0d1ce-8bf4-725b-ba79-00ba40c5db25",
        "storage_key": "property/5175251218464768/01a0d1ce-8bf4-725b-ba79-00ba40c5db25.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom, featuring a comfortable queen-size bed, soft linens, and ample natural light from the large window.",
      "link": "false",
      "alt_text": "A cozy bedroom with a queen-size bed, plush bedding, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (28).JPG"
    },
    {
      "id": "ec_d3eeccd9ad9e7455aa1c20d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-ac6d-75bf-845d-17b64648966d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with double sink and light wood cabinets.",
        "public_id": "01a0d1ce-ac6d-75bf-845d-17b64648966d",
        "storage_key": "property/5175251218464768/01a0d1ce-ac6d-75bf-845d-17b64648966d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a double sink, ample cabinet storage, and a breakfast bar overlooking the dining area.",
      "link": "false",
      "alt_text": "Modern kitchen with double sink and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (24).JPG"
    },
    {
      "id": "ec_4321420504d4cd346c3d399f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-cc16-7772-a74d-ab4930fa22b3.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with water heater and shelving.",
        "public_id": "01a0d1ce-cc16-7772-a74d-ab4930fa22b3",
        "storage_key": "property/5175251218464768/01a0d1ce-cc16-7772-a74d-ab4930fa22b3.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, complete with a water heater and shelving for all your laundry needs.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with water heater and shelving.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (26).JPG"
    },
    {
      "id": "ec_5cf5bcdbbefddebb0b6d1796",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-ce05-71e6-a66d-a5818242beff.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, fireplace, and bar area.",
        "public_id": "01a0d1ce-ce05-71e6-a66d-a5818242beff",
        "storage_key": "property/5175251218464768/01a0d1ce-ce05-71e6-a66d-a5818242beff.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our community lounge, featuring a pool table, cozy fireplace, and a full-service bar perfect for entertaining.",
      "link": "false",
      "alt_text": "Community lounge with pool table, fireplace, and bar area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (31).JPG"
    },
    {
      "id": "ec_30b7693b7fd44be1cef3e809",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-d11b-7732-81ca-c3bf42f04329.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table and fireplace.",
        "public_id": "01a0d1ce-d11b-7732-81ca-c3bf42f04329",
        "storage_key": "property/5175251218464768/01a0d1ce-d11b-7732-81ca-c3bf42f04329.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our stylish community lounge, featuring a fireplace and billiards table for endless entertainment.",
      "link": "false",
      "alt_text": "Community lounge with pool table and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (36).jpg"
    },
    {
      "id": "ec_0a660c45a6411d584175e5bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-d5ce-723b-98c0-d44e3366ffbb.webp",
      "image_media": {
        "alt_text": "Treadmills, elliptical, stationary bike, and weight machine in a well-lit fitness center.",
        "public_id": "01a0d1ce-d5ce-723b-98c0-d44e3366ffbb",
        "storage_key": "property/5175251218464768/01a0d1ce-d5ce-723b-98c0-d44e3366ffbb.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with cardio machines and weights for residents.",
      "link": "false",
      "alt_text": "Treadmills, elliptical, stationary bike, and weight machine in a well-lit fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (41).JPG"
    },
    {
      "id": "ec_8a808e2af2ed89250c53c76b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1ce-eb6e-756c-aa4d-cf36a77e3650.webp",
      "image_media": {
        "alt_text": "Balcony with seating area overlooking neighborhood",
        "public_id": "01a0d1ce-eb6e-756c-aa4d-cf36a77e3650",
        "storage_key": "property/5175251218464768/01a0d1ce-eb6e-756c-aa4d-cf36a77e3650.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on your private balcony, complete with comfortable seating and scenic views.",
      "link": "false",
      "alt_text": "Balcony with seating area overlooking neighborhood",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (43).JPG"
    },
    {
      "id": "ec_36b0a50296445a2fd1b4a2ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019f0254-1b9a-72ac-859f-e04872f8bb9e.webp",
      "image_media": {
        "alt_text": "Apartment complex with a large outdoor swimming pool, lounge chairs, and palm trees.",
        "public_id": "019f0254-1b9a-72ac-859f-e04872f8bb9e",
        "storage_key": "property/5175251218464768/019f0254-1b9a-72ac-859f-e04872f8bb9e.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool at our apartment community. Enjoy the sun from comfortable lounge chairs and soak in the resort-like atmosphere with lush landscaping and palm trees.",
      "link": "false",
      "alt_text": "Apartment complex with a large outdoor swimming pool, lounge chairs, and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/palms-at-brairwood-1.JPG"
    },
    {
      "id": "ec_67bf826c40e0ddc5f7fd0012",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-204f-7418-8edb-cc080730ec42.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "019d019c-204f-7418-8edb-cc080730ec42",
        "storage_key": "property/5175251218464768/019d019c-204f-7418-8edb-cc080730ec42.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax by the sparkling resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for soaking up the sun and enjoying the outdoors.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/palms-at-brairwood-3.JPG"
    },
    {
      "id": "ec_d253042de5b84c9e4124d39e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019f0254-19b5-7511-a3e6-b92dc239a3ea.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with apartment buildings in the background.",
        "public_id": "019f0254-19b5-7511-a3e6-b92dc239a3ea",
        "storage_key": "property/5175251218464768/019f0254-19b5-7511-a3e6-b92dc239a3ea.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, featuring comfortable lounge chairs and a tranquil atmosphere.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and lounge chairs with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (30).JPG"
    },
    {
      "id": "ec_c5fdd5f890029ee9d5bd40bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1cf-0a1f-709e-827e-77c9901e62bd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas, with apartment buildings in the background.",
        "public_id": "01a0d1cf-0a1f-709e-827e-77c9901e62bd",
        "storage_key": "property/5175251218464768/01a0d1cf-0a1f-709e-827e-77c9901e62bd.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, featuring comfortable lounge chairs and shaded seating areas perfect for enjoying the sunshine.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas, with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (39).jpg"
    },
    {
      "id": "ec_ba89a6bef0525e1ba0aafc6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019f0254-1503-733d-a70d-b49f6a67caff.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, tables, umbrellas, and a grill.",
        "public_id": "019f0254-1503-733d-a70d-b49f6a67caff",
        "storage_key": "property/5175251218464768/019f0254-1503-733d-a70d-b49f6a67caff.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge seating and convenient grilling stations for outdoor entertaining.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs, tables, umbrellas, and a grill.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/palms-at-brairwood-4.JPG"
    },
    {
      "id": "ec_825c8c6857a404372feaced9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-204f-7418-8edb-cc080730ec42.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "019d019c-204f-7418-8edb-cc080730ec42",
        "storage_key": "property/5175251218464768/019d019c-204f-7418-8edb-cc080730ec42.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax by the sparkling resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for soaking up the sun and enjoying the outdoors.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (38).JPG"
    },
    {
      "id": "ec_52f690031a72ebf8610eadcb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1cf-0cdc-75be-91e8-36612a00239b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
        "public_id": "01a0d1cf-0cdc-75be-91e8-36612a00239b",
        "storage_key": "property/5175251218464768/01a0d1cf-0cdc-75be-91e8-36612a00239b.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Community",
      "description": "Discover comfortable living in these beautiful apartment buildings, surrounded by lush green spaces and well-maintained pathways.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (21)_websize.jpg"
    },
    {
      "id": "ec_8e3d47e488355819966ec916",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1cf-14b4-75bd-be75-7d714bb76502.webp",
      "image_media": {
        "alt_text": "Community clubhouse exterior with a sandbox in the foreground.",
        "public_id": "01a0d1cf-14b4-75bd-be75-7d714bb76502",
        "storage_key": "property/5175251218464768/01a0d1cf-14b4-75bd-be75-7d714bb76502.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Exterior of the community clubhouse, featuring a sandbox and landscaping, with apartment buildings in the background.",
      "link": "false",
      "alt_text": "Community clubhouse exterior with a sandbox in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (34).jpg"
    },
    {
      "id": "ec_cc36f46fa3d6e7764d9023bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/01a0d1cf-17e0-7048-9c4e-26ceb51b781f.webp",
      "image_media": {
        "alt_text": "The Palms at Briarwood apartment complex exterior with manicured landscaping and a monument sign.",
        "public_id": "01a0d1cf-17e0-7048-9c4e-26ceb51b781f",
        "storage_key": "property/5175251218464768/01a0d1cf-17e0-7048-9c4e-26ceb51b781f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Palms at Briarwood, a premier apartment community offering beautiful exteriors and lush landscaping.",
      "link": "false",
      "alt_text": "The Palms at Briarwood apartment complex exterior with manicured landscaping and a monument sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Palms_at_Briarwood_Favorites (37).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f953ed36-1099-4d3e-b72d-4f38112c0b71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "4512 W Loop 250 N, Midland, TX 79707, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, prime rib, and other dishes, and the rolls with cinnamon butter are a highlight. They also highlight the attentive and friendly service, and the fun, welcoming atmosphere.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-051f-728e-a1e7-c9b7c8df4c27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-051f-728e-a1e7-c9b7c8df4c27",
        "storage_key": "property/5175251218464768/019d019d-051f-728e-a1e7-c9b7c8df4c27.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/midland?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=5910698450389592474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.0280176",
      "poi_longitude": "-102.1484095",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-689-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31d1-7121-aaa2-b6d86375374f",
        "storage_key": "property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWOq92PZ-4YRmmnspewEB1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_79585b47-0a52-4cb9-a9be-919a0f7a58b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Cork & Pig Tavern",
      "poi_type": "Restaurants",
      "poi_address": "200 Spring Park Dr Suite 200, Midland, TX 79705, USA",
      "poi_short_description": "Easygoing gastropub offering wood-fired pizza, American fare & many wines in contemporary digs.",
      "poi_long_description": "People say this restaurant serves delicious halibut, smash burgers, and pizza, especially The Pig. They also highlight the knowledgeable staff, fun cocktails, and great atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-053c-7488-9690-59ddb5b29518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-053c-7488-9690-59ddb5b29518",
        "storage_key": "property/5175251218464768/019d019d-053c-7488-9690-59ddb5b29518.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corkandpig.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17198830025515065311&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cork--pig-tavern",
      "poi_latitude": "32.0327302",
      "poi_longitude": "-102.081978",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-400-4121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31d1-7121-aaa2-b6d86375374f",
        "storage_key": "property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJUmmNJbZ-4YR398l78iEru4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_43bd76cc-3bda-4459-ae57-27ae2a52d8fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Bubba's 33",
      "poi_type": "Restaurants",
      "poi_address": "3315 W Loop 250 N, Midland, TX 79705, USA",
      "poi_short_description": "Burgers, pizza & beer served alongside many large-screen TVs showing sports & music videos.",
      "poi_long_description": "People say this restaurant serves great wings, Philly cheese steak, and spinach dip. They also highlight the quick service, friendly staff, and fun atmosphere, especially during sporting events.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-0560-74dd-802b-d756c45aa538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-0560-74dd-802b-d756c45aa538",
        "storage_key": "property/5175251218464768/019d019d-0560-74dd-802b-d756c45aa538.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.bubbas33.com/locations/texas/midland?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=12091521845305384417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bubbas-33",
      "poi_latitude": "32.03224",
      "poi_longitude": "-102.1308747",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-694-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31d1-7121-aaa2-b6d86375374f",
        "storage_key": "property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZiIZ45h-YYR4Z1N_w23zac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8fce3408-9929-46aa-88d4-e48e6da346b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1407 N Loop 250 W, Midland, TX 79706, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers and the signature Cane's bread. They also highlight the friendly and efficient staff, and the clean and inviting atmosphere.\n\nSome reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-0586-74a9-83df-70739f71ebc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-0586-74a9-83df-70739f71ebc9",
        "storage_key": "property/5175251218464768/019d019d-0586-74a9-83df-70739f71ebc9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/midland/1407-north-loop-250-west",
      "poi_directions_map_url": "https://maps.google.com/?cid=3448798928373067920&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "31.99486769999999",
      "poi_longitude": "-102.1539716",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-689-0504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31d1-7121-aaa2-b6d86375374f",
        "storage_key": "property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-dsrJPZ-4YRkLBsU1qY3C8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_16f9f89c-0bd1-4a58-a965-6f94aa0b7600",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "La Florida Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "200 W Florida Ave, Midland, TX 79701, USA",
      "poi_short_description": "Casual option serving classic Mexican fare like menudo, chilaquiles and enchiladas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-096b-77da-8b6b-dc3201e2b5ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-096b-77da-8b6b-dc3201e2b5ba",
        "storage_key": "property/5175251218464768/019d019d-096b-77da-8b6b-dc3201e2b5ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lafloridamexicanrestauranttx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14582106088763636640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-florida-mexican-restaurant",
      "poi_latitude": "31.9894259",
      "poi_longitude": "-102.0756595",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 432-247-1343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31d1-7121-aaa2-b6d86375374f",
        "storage_key": "property/5175251218464768/019d019d-31d1-7121-aaa2-b6d86375374f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9I7oSrZ-4YRoDvReToMXso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a510d17b-388d-455b-8114-782baf9d52db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Midland Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "4511 N Midkiff Rd, Midland, TX 79705, USA",
      "poi_short_description": "Casual shopping center offering familiar chain retailers, restaurants & a children's play area.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and stores, including popular brands. They also highlight the clean and open atmosphere, and the fun activities like trampoline jumping and RC cars.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-0a28-768b-9b7d-6fdf677de48e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-0a28-768b-9b7d-6fdf677de48e",
        "storage_key": "property/5175251218464768/019d019d-0a28-768b-9b7d-6fdf677de48e.webp",
        "width": 1100,
        "height": 773
      },
      "poi_business_url": "https://www.simon.com/mall/midland-park-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=8691727017798498722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midland-park-mall",
      "poi_latitude": "32.0304055",
      "poi_longitude": "-102.1317351",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-694-1663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31f4-7446-9907-e74fc58f1cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31f4-7446-9907-e74fc58f1cce",
        "storage_key": "property/5175251218464768/019d019d-31f4-7446-9907-e74fc58f1cce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl4w-YTrZ-4YRonmLBKw3n3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f575a011-2b21-47f3-8c53-85bc22eb745d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "3325 W Wadley Ave, Midland, TX 79707, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, and home brand foods, as well as seasonal items. They highlight the reasonable prices and the convenient one-stop shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-0a19-7238-bf2b-5106b3f5374d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-0a19-7238-bf2b-5106b3f5374d",
        "storage_key": "property/5175251218464768/019d019d-0a19-7238-bf2b-5106b3f5374d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/midland/west-wadley-h-e-b-382?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=15234912354204858128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "32.0182147",
      "poi_longitude": "-102.1257597",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-697-1471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31f4-7446-9907-e84e7728b236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31f4-7446-9907-e84e7728b236",
        "storage_key": "property/5175251218464768/019d019d-31f4-7446-9907-e84e7728b236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUctVRjZ-4YREDeXcBFIbdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_545711f4-5dcd-480a-8a28-5442a6de8fd1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4009 Midland Dr, Midland, TX 79707, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful staff and a wide selection of tools. They also highlight the knowledgeable staff who can provide assistance with paint matching and other projects.\n\nSome reviews mention the self-checkout can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-0e54-70ab-a95f-d761150d97f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-0e54-70ab-a95f-d761150d97f8",
        "storage_key": "property/5175251218464768/019d019d-0e54-70ab-a95f-d761150d97f8.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Midland/TX/Midland/79707/561?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1693684149658725859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "32.0225814",
      "poi_longitude": "-102.146862",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-694-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31f4-7446-9907-e74fc58f1cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31f4-7446-9907-e74fc58f1cce",
        "storage_key": "property/5175251218464768/019d019d-31f4-7446-9907-e74fc58f1cce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjQEf5mPZ-4YR4y0etsIsgRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_eec686b2-2ef7-437a-b894-eb6277000814",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "3315 N Loop 250 W, Midland, TX 79707, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products. They also highlight the good prices and fast checkout.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-0e9d-702d-88a0-8c55069de43d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-0e9d-702d-88a0-8c55069de43d",
        "storage_key": "property/5175251218464768/019d019d-0e9d-702d-88a0-8c55069de43d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Midland/0063?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-63-_-na-_-0-_-0&y_source=1_MTE4MzM1Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=841949447913071900&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.012",
      "poi_longitude": "-102.1596",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-689-2828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31f4-7446-9907-e74fc58f1cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31f4-7446-9907-e74fc58f1cce",
        "storage_key": "property/5175251218464768/019d019d-31f4-7446-9907-e74fc58f1cce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLSKymWHZ-4YRHOWx4Y80rws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c30ab0f0-a0ae-4941-a3ab-fcc33bcbc0ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Midland College",
      "poi_type": "Education",
      "poi_address": "3600 N Garfield St, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-0f32-7463-9033-5d0e5b32840e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-0f32-7463-9033-5d0e5b32840e",
        "storage_key": "property/5175251218464768/019d019d-0f32-7463-9033-5d0e5b32840e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.midland.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12902905061812523829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midland-college",
      "poi_latitude": "32.0297923",
      "poi_longitude": "-102.1085317",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-685-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-31f4-7446-9907-e30b7fe85e36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-31f4-7446-9907-e30b7fe85e36",
        "storage_key": "property/5175251218464768/019d019d-31f4-7446-9907-e30b7fe85e36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl7OGydvY-4YRNdPsi8pTELM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7a6ccc21-4203-410f-98dd-b2f6203b42d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Astound Broadband Stadium",
      "poi_type": "Entertainment",
      "poi_address": "801 N Loop 250 W, Midland, TX 79703, USA",
      "poi_short_description": "Football stadium with restrooms and concessions, also used for graduations.",
      "poi_long_description": "People say this stadium offers a beautiful, well-maintained field and decent seats. They highlight the great teamwork and sense of community during events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-0fd2-74de-b610-24068e3393d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-0fd2-74de-b610-24068e3393d7",
        "storage_key": "property/5175251218464768/019d019d-0fd2-74de-b610-24068e3393d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9618717631948349240&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "astound-broadband-stadium",
      "poi_latitude": "31.9892525",
      "poi_longitude": "-102.153937",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-365e-766b-9ade-123a7419f3eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-365e-766b-9ade-123a7419f3eb",
        "storage_key": "property/5175251218464768/019d019d-365e-766b-9ade-123a7419f3eb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNRNGypzZ-4YROF8RX7mMfIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_7bf01120-ec83-4286-b244-4320b7f6117a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Permian Basin Petroleum Museum",
      "poi_type": "Entertainment",
      "poi_address": "1500 I-20, Midland, TX 79701, USA",
      "poi_short_description": "Interactive exhibits interpret the history of oil, its geology & the industry's modern roots.",
      "poi_long_description": "People say this museum offers a comprehensive and informative experience about the history of petroleum, with extensive collections and interactive exhibits. They highlight the museum's engaging and educational content, suitable for all ages, and the beautiful displays, including a mineral exhibit and art exhibition. They also like the friendly and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://petroleummuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17173222098646240074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "permian-basin-petroleum-museum",
      "poi_latitude": "31.9720665",
      "poi_longitude": "-102.0851728",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 432-683-4403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-365c-7574-9e5c-8e8f2f02b0c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-365c-7574-9e5c-8e8f2f02b0c8",
        "storage_key": "property/5175251218464768/019d019d-365c-7574-9e5c-8e8f2f02b0c8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSwNsBHY-4YRSouy1oKKU-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_392ae578-49eb-44ed-b72c-4db7a22cad08",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "4706 N Midkiff Rd Suite 1, Midland, TX 79705, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, climbing walls, and obstacle courses, and is a great place for kids to burn off energy.\n\nOther reviews mention the management can be unprofessional and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-12e2-750d-8b3f-9293f99c04b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-12e2-750d-8b3f-9293f99c04b4",
        "storage_key": "property/5175251218464768/019d019d-12e2-750d-8b3f-9293f99c04b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/texas-midland/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3061065795057559343&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.0359959",
      "poi_longitude": "-102.1287393",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-203-0283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_epi9rHZ-4YRLyeBVB8Xeyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_367b7946-8c8e-4b02-ad3a-eaf169ba3d01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Momentum Bank Ballpark",
      "poi_type": "Entertainment",
      "poi_address": "5514 Champions Dr, Midland, TX 79706, USA",
      "poi_short_description": "Ballpark for the local minor league team with a splash pad and picnic area.",
      "poi_long_description": "People say this stadium offers a fun experience with a variety of concessions and comfortable seating with great views. They highlight the family-friendly atmosphere, engaging activities for children, and the friendly, approachable players. They also like the clean, well-maintained facilities, easy parking, and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.milb.com/midland/ballpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=10615644297587624904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "momentum-bank-ballpark",
      "poi_latitude": "31.9873688",
      "poi_longitude": "-102.1559406",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-520-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-365e-766b-9ade-123a7419f3eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-365e-766b-9ade-123a7419f3eb",
        "storage_key": "property/5175251218464768/019d019d-365e-766b-9ade-123a7419f3eb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlV7UtIXZ-4YRyIucmz5YUpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_21ff2d2c-2305-4f56-82ae-5d6bd7241091",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Museum of the Southwest",
      "poi_type": "Entertainment",
      "poi_address": "1705 W Missouri Ave, Midland, TX 79701, USA",
      "poi_short_description": "Institute housed in the 1934 Turner Mansion showcasing regional art, culture, science & archaeology.",
      "poi_long_description": "Institute housed in the 1934 Turner Mansion showcasing regional art, culture, science & archaeology.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-12a6-71cc-9461-28badc00b63b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-12a6-71cc-9461-28badc00b63b",
        "storage_key": "property/5175251218464768/019d019d-12a6-71cc-9461-28badc00b63b.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.museumsw.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13655888659356262876&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-the-southwest",
      "poi_latitude": "31.993304",
      "poi_longitude": "-102.092519",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-683-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-365c-7574-9e5c-8e8f2f02b0c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-365c-7574-9e5c-8e8f2f02b0c8",
        "storage_key": "property/5175251218464768/019d019d-365c-7574-9e5c-8e8f2f02b0c8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJeWPFqGfY-4YR3CE3OWJ2g70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_25468748-4826-4977-9c41-b14a50ba5d3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 N Midkiff Rd, Midland, TX 79701, USA",
      "poi_short_description": "Chain gym in Town&Country Shopping Center offering tanning beds, massages, and a friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of machines and equipment, as well as Black Card Spa amenities. They also highlight the clean facilities, spacious locker rooms, and friendly, helpful staff.\n\nOther reviews mention some machines can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-13c8-731b-8a8f-1c19f8f291f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-13c8-731b-8a8f-1c19f8f291f7",
        "storage_key": "property/5175251218464768/019d019d-13c8-731b-8a8f-1c19f8f291f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/midland-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1617383553482956190&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.0014621",
      "poi_longitude": "-102.1182505",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-689-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_kSHADZ-4YRnh3pysUZchY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bb9cd961-9dc8-4038-9794-03ea82f8bab7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Crunch Fitness - Midland",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 N Loop 250 W, Midland, TX 79707, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment and the staff is friendly.\n\nOther reviews mention the equipment can be broken and the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-14c2-77ec-83a7-118fe64224e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-14c2-77ec-83a7-118fe64224e2",
        "storage_key": "property/5175251218464768/019d019d-14c2-77ec-83a7-118fe64224e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/midland",
      "poi_directions_map_url": "https://maps.google.com/?cid=6502439180609717262&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---midland",
      "poi_latitude": "32.0107498",
      "poi_longitude": "-102.1551361",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-242-6599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqz04jh3Z-4YRDgTTvftNPVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f58104ee-04ee-477b-9782-2e2534863838",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs - Midland Dr.",
      "poi_type": "Health and Wellness",
      "poi_address": "3404 Midland Dr, Midland, TX 79707, USA",
      "poi_short_description": "Chain gym offering equipment, classes, and pre-workout gummies, as well as child care.",
      "poi_long_description": "Gym goers say this gym has a wide variety of equipment, a clean facility, and friendly, helpful staff. They also highlight the motivating group classes and knowledgeable training staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-1751-707c-897c-9f79924bc9ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-1751-707c-897c-9f79924bc9ba",
        "storage_key": "property/5175251218464768/019d019d-1751-707c-897c-9f79924bc9ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/midland/midland-dr/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8365357079551124348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs---midland-dr",
      "poi_latitude": "32.0180867",
      "poi_longitude": "-102.1405883",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-251-2229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeaVTQ0bZ-4YRfKPxOfG3F3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_32625392-bd96-4a6b-9b18-fe47972930be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Relentless Strength & Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 N A St building 3 suite 100, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of high-end equipment and machines, including specialty equipment, and is always clean and well-maintained. They highlight the friendly and welcoming atmosphere, and the knowledgeable and approachable owners. They also like the helpful and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-181e-764e-b22e-b4e8bace2b3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-181e-764e-b22e-b4e8bace2b3a",
        "storage_key": "property/5175251218464768/019d019d-181e-764e-b22e-b4e8bace2b3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.relentlessstrengthandfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17673488975044422014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "relentless-strength--fitness",
      "poi_latitude": "32.0299416",
      "poi_longitude": "-102.0906857",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-664-8120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUipGkPZ-4YRfilOq5XYRPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5797e238-b290-41e1-b34d-c1d0e918cf19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs - Meta Dr",
      "poi_type": "Health and Wellness",
      "poi_address": "3 Meta Dr, Midland, TX 79701, USA",
      "poi_short_description": "Spacious, clean, organized gym offering classes, weights and cardio machines, as well as a ladies' gym.",
      "poi_long_description": "Gym goers say this gym has a spacious, clean facility with a welcoming atmosphere and friendly, helpful staff, especially Mercedes. They also highlight the great customer service and excellent childcare services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-185e-76da-8ad7-252e53878164.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-185e-76da-8ad7-252e53878164",
        "storage_key": "property/5175251218464768/019d019d-185e-76da-8ad7-252e53878164.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/midland/meta-dr/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17729717407588200877&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs---meta-dr",
      "poi_latitude": "31.9932842",
      "poi_longitude": "-102.1008317",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-683-4654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ZfJhVvY-4YRrbFazwucDPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dd34fa68-02bf-4958-93a9-a7ce6025c434",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Legacy Animal Emergency Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2304 W Wadley Ave, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-1a24-7328-8e4b-b979dbeda7b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-1a24-7328-8e4b-b979dbeda7b4",
        "storage_key": "property/5175251218464768/019d019d-1a24-7328-8e4b-b979dbeda7b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/pages/category/Veterinarian/Legacy-Animal-Emergency-Hospital-103612021598897/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1342708208439065447&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legacy-animal-emergency-hospital",
      "poi_latitude": "32.0236223",
      "poi_longitude": "-102.1100834",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-247-1425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RJaNizZ-4YRZ_sCaQBCohI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_db827fdb-1c33-4da1-be92-a95b3b3f3178",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "3408 N Midkiff Rd Ste 203, Midland, TX 79705, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-1cd2-7598-a0c0-581a1df5b1c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-1cd2-7598-a0c0-581a1df5b1c1",
        "storage_key": "property/5175251218464768/019d019d-1cd2-7598-a0c0-581a1df5b1c1.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/tx/midland/3408-midkiff?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6946918061512141291&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "32.0233101",
      "poi_longitude": "-102.1254258",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-247-5130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQNy9WXZ-4YR6yktrCtpaGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_636a22a5-30f7-4899-a3c2-de4824df807e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Midland",
      "poi_type": "Health and Wellness",
      "poi_address": "3208 N Loop 250 W Suite 400, Midland, TX 79707, USA",
      "poi_short_description": "Casual spot (part of a chain) for haircuts, beard trims and steamed-towel treatments in a sporty atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-1d0f-72cf-bab9-6a0f1a1d1604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-1d0f-72cf-bab9-6a0f1a1d1604",
        "storage_key": "property/5175251218464768/019d019d-1d0f-72cf-bab9-6a0f1a1d1604.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-tx-midland-tx730?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9136176714823025543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-midland",
      "poi_latitude": "32.0111563",
      "poi_longitude": "-102.1569644",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-689-8786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2Ydc2TZ-4YRh8M4DFE4yn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_bad00a3a-a666-44d4-8081-bd0a88f20564",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "A to Z Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "8535 TX-158, Midland, TX 79707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-1dcd-710c-bee9-47d180953685.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-1dcd-710c-bee9-47d180953685",
        "storage_key": "property/5175251218464768/019d019d-1dcd-710c-bee9-47d180953685.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.atozvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15695489641425188570&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "a-to-z-veterinary-clinic",
      "poi_latitude": "32.0140862",
      "poi_longitude": "-102.2097101",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-520-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTiobHXb-4YR2rb4rKuU0dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_262eff58-208a-45de-ae49-e0ead904ae9a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Aces & Eights Barber Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "3303 N Midkiff Rd #170, Midland, TX 79705, USA",
      "poi_short_description": "Classic men's cuts, beard trims & razor shaves are the focus at this old-school barbershop",
      "poi_long_description": "Classic men's cuts, beard trims & razor shaves are the focus at this old-school barbershop",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-1ebe-773a-8546-5fa72f0d7291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-1ebe-773a-8546-5fa72f0d7291",
        "storage_key": "property/5175251218464768/019d019d-1ebe-773a-8546-5fa72f0d7291.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.barbershopmidland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4496308149205338687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aces--eights-barber-shop",
      "poi_latitude": "32.0213995",
      "poi_longitude": "-102.126272",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-262-1184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93mR38rZ-4YRPwoUcnAYZj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_79066122-8cb6-4010-ac22-bea27fc55202",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Midland Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Rosalind Redfern Grover Pkwy, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-2111-7621-8f8e-183755dd24e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-2111-7621-8f8e-183755dd24e6",
        "storage_key": "property/5175251218464768/019d019d-2111-7621-8f8e-183755dd24e6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.midlandhealth.org/?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=75874490978375239&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midland-memorial-hospital",
      "poi_latitude": "31.9966379",
      "poi_longitude": "-102.0996046",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-221-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35da-756f-bfa3-9ee1b9d465ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35da-756f-bfa3-9ee1b9d465ba",
        "storage_key": "property/5175251218464768/019d019d-35da-756f-bfa3-9ee1b9d465ba.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4USlpV7Y-4YRR5ZHknKPDQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f4cfd901-8831-4433-809c-55c65e29b59a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Clinica Hispana Midland",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 W Illinois Ave #1b1, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-2299-714b-9e26-205eaed35d5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-2299-714b-9e26-205eaed35d5a",
        "storage_key": "property/5175251218464768/019d019d-2299-714b-9e26-205eaed35d5a.webp",
        "width": 1138,
        "height": 640
      },
      "poi_business_url": "http://www.clinicahispanamidland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9790022222952796504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clinica-hispana-midland",
      "poi_latitude": "31.9928109",
      "poi_longitude": "-102.1096275",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-262-0160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35da-756f-bfa3-9ee1b9d465ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35da-756f-bfa3-9ee1b9d465ba",
        "storage_key": "property/5175251218464768/019d019d-35da-756f-bfa3-9ee1b9d465ba.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnaa94qrZ-4YRWBFIjlcl3Yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_65a29d62-ac74-46ac-9a28-87c0d6bf1c1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Summit Center Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3200 Mockingbird Ln Building 7, Suite 100, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a modern playground, wide lawns, and shaded seating areas, perfect for families and picnics. They highlight the clean, well-maintained, and versatile space, suitable for various activities like playing, relaxing, and strolling. They also like the convenient access to nearby dining and retail options, making it easy to spend a few hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-222a-761d-9b31-34a246bb6e8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-222a-761d-9b31-34a246bb6e8a",
        "storage_key": "property/5175251218464768/019d019d-222a-761d-9b31-34a246bb6e8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://summitcentermidland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4503262350404343266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "summit-center-park",
      "poi_latitude": "32.048759",
      "poi_longitude": "-102.132344",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-3935-748e-97d7-20bb8c7f2454.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-3935-748e-97d7-20bb8c7f2454",
        "storage_key": "property/5175251218464768/019d019d-3935-748e-97d7-20bb8c7f2454.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2-cFQDf-4YR4tU9lj_Nfj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3780442e-5243-493f-a23d-4e4c29c285a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Beal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 W Wall St, Midland, TX 79703, USA",
      "poi_short_description": "Sizable area featuring a playground, sports facilities, an off-leash dog park & a fishing pond.",
      "poi_long_description": "People say this city park offers fishing, walking trails, a skate park, a playground, and covered picnic areas. They highlight the park is a great place to walk, play, and fish, and that there are plenty of trees for shade. They also like the cute playground and the small pond. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-23c7-7097-a7ab-238dec264fbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-23c7-7097-a7ab-238dec264fbe",
        "storage_key": "property/5175251218464768/019d019d-23c7-7097-a7ab-238dec264fbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.midlandtexas.gov/Facilities/Facility/Details/Beal-Park-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=7756242855263869794&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beal-park",
      "poi_latitude": "31.965182",
      "poi_longitude": "-102.1385535",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-685-7356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-3935-748e-97d7-20bb8c7f2454.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-3935-748e-97d7-20bb8c7f2454",
        "storage_key": "property/5175251218464768/019d019d-3935-748e-97d7-20bb8c7f2454.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwD9QMLZ-4YRYhuqU8i1o2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_578bc350-b41a-4b6b-b749-182619956e22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Dennis the Menace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2201 W Indiana Ave, Midland, TX 79701, USA",
      "poi_short_description": "Colorful 4-acre park featuring a playground, picnic tables, BBQ pits, a pavilion & restrooms.",
      "poi_long_description": "People say this park offers a variety of playgrounds, a splash pad, and fitness equipment. They highlight the clean and spacious play areas, and the availability of shade and picnic tables. They also like the free admission and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-25d6-71ac-bf5f-1830c99d5676.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-25d6-71ac-bf5f-1830c99d5676",
        "storage_key": "property/5175251218464768/019d019d-25d6-71ac-bf5f-1830c99d5676.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.midlandtexas.gov/facilities/facility/details/Dennis-the-Menace-Park-15",
      "poi_directions_map_url": "https://maps.google.com/?cid=12862990864927425442&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dennis-the-menace-park",
      "poi_latitude": "31.9907239",
      "poi_longitude": "-102.0978675",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-685-7356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-3935-748e-97d7-20bb8c7f2454.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-3935-748e-97d7-20bb8c7f2454",
        "storage_key": "property/5175251218464768/019d019d-3935-748e-97d7-20bb8c7f2454.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRTG1lzY-4YRogMYZQqGgrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b191b783-572c-40dc-a644-d70971fb0c0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Watersong Wild Space",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2201 S Midland Dr, Midland, TX 79703, USA",
      "poi_short_description": "Urban playa lake habitat with hiking trails & wildlife spotting from viewing platforms & blinds.",
      "poi_long_description": "People say this nature preserve offers a beautiful walk with opportunities to observe wildlife, birds, and native plants. They highlight the well-maintained trails, scenic overlooks, and peaceful atmosphere, perfect for a relaxing escape. They also like the convenient location within an urban landscape.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-26b9-76e8-b7c9-4e96636cb794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-26b9-76e8-b7c9-4e96636cb794",
        "storage_key": "property/5175251218464768/019d019d-26b9-76e8-b7c9-4e96636cb794.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.watersong.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17678376154120734455&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "watersong-wild-space",
      "poi_latitude": "31.96169",
      "poi_longitude": "-102.123738",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-853-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-3935-748e-97d7-20bb8c7f2454.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-3935-748e-97d7-20bb8c7f2454",
        "storage_key": "property/5175251218464768/019d019d-3935-748e-97d7-20bb8c7f2454.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqd3oZNHZ-4YR90YauHI1VvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_96307306-7abc-4c9a-9de4-0cd162bf73b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Hogan Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3600 N Fairgrounds Rd, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-2710-7273-ad89-2f6f8e6afdde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-2710-7273-ad89-2f6f8e6afdde",
        "storage_key": "property/5175251218464768/019d019d-2710-7273-ad89-2f6f8e6afdde.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.midlandtexas.gov/1080/Hogan-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14391185496259734030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hogan-park-golf-course",
      "poi_latitude": "32.0408956",
      "poi_longitude": "-102.0637157",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-685-7360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-3935-748e-97d7-1ff2556c51c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-3935-748e-97d7-1ff2556c51c1",
        "storage_key": "property/5175251218464768/019d019d-3935-748e-97d7-1ff2556c51c1.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJzT_7rRpi-YYRDqpQCfbCt8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_63d49bb2-2e51-4b0f-999f-719d27659e98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Midland Airpark",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Veterans Airpark Ln, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-291d-77f0-b5a9-b270076aca10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-291d-77f0-b5a9-b270076aca10",
        "storage_key": "property/5175251218464768/019d019d-291d-77f0-b5a9-b270076aca10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flymaf.com/149/Midland-Executive-Airpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=9810408844524569748&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midland-airpark",
      "poi_latitude": "32.0331878",
      "poi_longitude": "-102.0970535",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-685-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-39d2-72df-b93d-a757d6b0c319.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-39d2-72df-b93d-a757d6b0c319",
        "storage_key": "property/5175251218464768/019d019d-39d2-72df-b93d-a757d6b0c319.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ4T9cXY-4YRlMQ8x92SJYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_36e28bf1-3901-4815-8a42-d2c99b166cd6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "XTO Energy Midland Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6401 Holiday Hl Rd, Midland, TX 79707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-2a37-736b-b90c-d2ba14a16e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-2a37-736b-b90c-d2ba14a16e34",
        "storage_key": "property/5175251218464768/019d019d-2a37-736b-b90c-d2ba14a16e34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://xtoenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15036565319082093750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "xto-energy-midland-office",
      "poi_latitude": "32.0509394",
      "poi_longitude": "-102.1723557",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-682-8873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5wX1hrc-4YRtqzYlX2crNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d4b98864-02c9-4a98-b671-db468bd05ebc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Oxy - Midland",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Gehrig Dr, Midland, TX 79706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-2bd5-725f-bde5-af5f4616b3b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-2bd5-725f-bde5-af5f4616b3b8",
        "storage_key": "property/5175251218464768/019d019d-2bd5-725f-bde5-af5f4616b3b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.oxy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14418470198711973448&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oxy---midland",
      "poi_latitude": "31.9938792",
      "poi_longitude": "-102.1628965",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-684-2994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRpkgbzY-4YRSHbI3kCyGMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_370e9663-13a7-48ca-8af2-0db7fb16c013",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Midland County Annex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2110 N A St, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-2c48-7199-a04d-51e28b1f049f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-2c48-7199-a04d-51e28b1f049f",
        "storage_key": "property/5175251218464768/019d019d-2c48-7199-a04d-51e28b1f049f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.co.midland.tx.us/236/Motor-Vehicles",
      "poi_directions_map_url": "https://maps.google.com/?cid=131445945903261410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midland-county-annex",
      "poi_latitude": "32.0192512",
      "poi_longitude": "-102.0878073",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-688-4810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUY9z2d_Z-4YR4qa6MGT90gE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9a248838-faa6-4699-b0e4-cab0ce47babb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "City of Midland City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Loraine St, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-2e33-71dc-9438-6e1965cccabe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-2e33-71dc-9438-6e1965cccabe",
        "storage_key": "property/5175251218464768/019d019d-2e33-71dc-9438-6e1965cccabe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.midlandtexas.gov/Facilities/Facility/Details/City-Hall-64",
      "poi_directions_map_url": "https://maps.google.com/?cid=7075327628908885444&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-midland-city-hall",
      "poi_latitude": "32.0000094",
      "poi_longitude": "-102.0754433",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 432-685-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-39d6-7568-9cd0-d1125e791309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-39d6-7568-9cd0-d1125e791309",
        "storage_key": "property/5175251218464768/019d019d-39d6-7568-9cd0-d1125e791309.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSnP5H7Y-4YRxPWe5v2cMGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_e8d55271-c7ed-474f-9d25-1252b0a0ceb3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "custom",
      "poi_name": "Jones Bros Lab",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Midland, TX 79707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11145887850324517422&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jones-bros-lab",
      "poi_latitude": "31.98906",
      "poi_longitude": "-102.224921",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 432-638-2855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-35d8-71f1-ba18-08365ffb6559",
        "storage_key": "property/5175251218464768/019d019d-35d8-71f1-ba18-08365ffb6559.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI_6GCuLa-4YRLmLvSPIlrpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6e0ec001cef36cc79ec73add",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fc230388d06f029aa4a2f9c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d70657c94e25436985232b29",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_776c096fed3921992df6a4a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ce5862c84294de271e40158f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_23032c2a20972b1e21a2ff5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d1d4da2d-a2dc-4f24-933c-e77074ba4ffa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "rating": "5.0",
      "name": "Katherine Mumm",
      "text": "Let me tell you about probably one of the best apartments I've ever had the opportunity of living in. Granted things went haywire at the start so many work orders ended up being placed. However,...between the maintenance staff and the office staff; this place has got to be one of the best apartment complexes I've had the chance of living in Grace herself is an amazing representative she is so friendly and caring and always has a smile on her face when you walk into the office door. The maintenance Crew The double A's as they call themselves Alexis and Angel are always friendly always respectful and always managed to get the job done. No questions asked and are willing to have a conversation with you while they're doing the job. If you could choose one place to live in Midland Texas choose the palms at briarwood.",
      "date": "2026-01-30",
      "title": ""
    },
    {
      "id": "custom_c7d33660-4aac-4770-915d-feb156f0b45d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "rating": "5.0",
      "name": "Francisco Olvera",
      "text": "I've been living here at the Palms for over 3 three years and has been an incredible experience. Previous and current management have been great! as well as maintanance staff are ready to help! They have been really helpful and understanding in making this a great place to live. Whether you live alone, with roomates or your family, you will surely make living here a true home! My three bedroom apartment is a perfect size for my family of 5! Not too mention the great pool and the Gym! The location here is also walking distance to Wal-Mart, and have many restaturants nearby!",
      "date": "2025-12-02",
      "title": ""
    },
    {
      "id": "custom_a954075e-169f-4eb1-8d44-c6717770a968",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "rating": "5.0",
      "name": "Brittany Briseno",
      "text": "Words can hardly capture how wonderful this place is, and how exceptional manager Erica is. There’s truly nothing like walking into the office and seeing her friendly face, along with her wonderful staff. I highly recommend making this your new home.",
      "date": "2025-11-20",
      "title": ""
    },
    {
      "id": "custom_646c91f6-4ff3-4089-abc9-487e7fb79812",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "rating": "5.0",
      "name": "Laura Leyva",
      "text": "This is an excellent place to live. It is always very clean and kept up with. Never had any problems with anyone and the management was always on top of everything. I would recommend living here.",
      "date": "2025-11-21",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_052ef3ecd45e733662be4e73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019d-4248-7668-832f-b9f7cd9cf2d1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with sofa, coffee table, dining area, and kitchen bar.",
        "public_id": "019d019d-4248-7668-832f-b9f7cd9cf2d1",
        "storage_key": "property/5175251218464768/019d019d-4248-7668-832f-b9f7cd9cf2d1.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "2BR, 2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rmu7CRwAYkz"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-68b3-7226-b99d-114d7833176a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-palms-at-briarwood",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768"
    },
    {
      "lead_collector_id": "0198aa47-6917-73fd-80c7-f4d4bd89b932",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-palms-at-briarwood",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768"
    },
    {
      "lead_collector_id": "0198aa47-697a-771d-9a7e-0e52f96d0a53",
      "lead_source": "LANDING_PAGE",
      "name": "the-palms-at-briarwood",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "pool-apartments-midland-tx",
      "search_query": "pool apartments in Midland TX",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Midland, TX",
      "h2_subtitle": "Discover pool apartments in Midland, TX at The Palms at Briarwood. Enjoy a refreshing lifestyle with our top amenities including a stunning swimming pool.",
      "page_copy": "If you're searching for pool apartments in Midland, TX, The Palms at Briarwood is the place to be. Our community offers residents a premium lifestyle with access to a sparkling swimming pool perfect for relaxing and enjoying the West Texas sun. Nestled in a convenient location, our stylish apartment homes are designed to meet all your needs, offering spacious layouts in one, two, or three-bedroom options.\n\nBeyond the pool, The Palms at Briarwood delights residents with amenities like a modern media room, a business center, and an off-leash dog park. Each apartment comes fitted with stainless steel appliances, walk-in closets, and ceiling fans. Whether you're cooling off by the pool or unwinding in your smoke-free apartment, you'll find comfort and luxury at every turn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Midland, TX - The Palms at Briarwood",
      "seo_description": "Explore pool apartments in Midland, TX at The Palms at Briarwood. Enjoy top amenities, a refreshing pool, and modern living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-briarwood",
      "search_query": "dog park apartments near Briarwood",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments near Briarwood",
      "h2_subtitle": "Looking for dog park apartments near Briarwood? The Palms at Briarwood offers an off-leash dog park and more.",
      "page_copy": "For those seeking dog park apartments near Briarwood, The Palms at Briarwood is the perfect choice. Our community is proud to provide a welcoming environment for pet lovers, featuring an off-leash dog park right on the premises. Your furry friends can enjoy plenty of space to run, play, and socialize in a safe and enjoyable setting.\n\nLocated in the heart of Midland, TX, our apartment homes offer more than just convenience. Choose from elegant one, two, or three-bedroom floor plans that include luxurious features like granite breakfast bars and walk-in closets. Alongside the dedicated dog park, residents can take advantage of additional amenities including a business center and a relaxing media room. Make living with your pet a breeze at The Palms at Briarwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near Briarwood - The Palms",
      "seo_description": "Find dog park apartments near Briarwood at The Palms. Enjoy a pet-friendly lifestyle with an off-leash park and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-midland-79707",
      "search_query": "air conditioned apartments Midland 79707",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Midland 79707",
      "h2_subtitle": "Explore air conditioned apartments in Midland, 79707 at The Palms at Briarwood. Enjoy modern comfort and top amenities in every unit.",
      "page_copy": "Finding comfort is easy when you choose air conditioned apartments in Midland's 79707 area at The Palms at Briarwood. Our modern units are designed to provide ultimate comfort, featuring ceiling fans and efficient air conditioning systems that ensure a cool environment even during the warmest Texas days.\n\nSituated in a prime location, The Palms at Briarwood offers more than just temperature-controlled living spaces. With options ranging from one to three-bedroom layouts, each apartment is thoughtfully equipped with stainless steel appliances and walk-in closets. Residents also enjoy community perks such as a business center and a media room, ideal for work and leisure. Experience the perfect blend of comfort and convenience today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Midland 79707 - The Palms",
      "seo_description": "Discover air conditioned apartments in Midland, 79707 at The Palms, offering modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-dishwasher-midland",
      "search_query": "apartments with in-unit laundry and dishwasher in Midland",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry & Dishwasher",
      "h2_subtitle": "Find apartments with in-unit laundry and dishwasher in Midland at The Palms at Briarwood. Experience the ease of modern living today.",
      "page_copy": "For those seeking convenience, The Palms at Briarwood offers apartments with in-unit laundry and dishwasher in Midland. Our thoughtfully designed homes cater to the needs of busy residents who desire modern amenities that make life simpler. Enjoy the ease of doing laundry any time and the efficiency of a dishwasher in every unit, making everyday chores hassle-free.\n\nLocated in the heart of Midland, The Palms at Briarwood presents a blend of style and practicality. Choose from spacious one, two, or three-bedroom layouts, each featuring sophisticated touches like stainless steel appliances and granite breakfast bars. Alongside your in-unit conveniences, take advantage of community amenities such as a media room and business center. Live effortlessly at The Palms at Briarwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry & Dishwasher - Midland",
      "seo_description": "Explore Midland apartments with in-unit laundry and dishwasher at The Palms, where ease meets modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-briarwood-midland",
      "search_query": "luxury apartments with fitness center Briarwood Midland",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center Briarwood",
      "h2_subtitle": "Discover luxury apartments with a fitness center at Briarwood in Midland. Enjoy upscale living with premium amenities.",
      "page_copy": "Experience upscale living at The Palms at Briarwood, luxury apartments with a fitness center conveniently located in Midland. Our community is designed for residents who value a blend of style, comfort, and fitness-friendly amenities. With access to a state-of-the-art fitness center, you can maintain a healthy lifestyle just steps from your door.\n\nAt The Palms, luxury goes beyond fitness facilities. Choose from elegant one, two, or three-bedroom layouts, each adorned with premium features such as stainless steel appliances and granite breakfast bars. Beyond the comfort of your home, enjoy the business center, media room, and dog park for a community that offers everything you need. Elevate your living experience at The Palms at Briarwood, where luxury and convenience meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center - Briarwood",
      "seo_description": "Find luxury apartments with a fitness center at Briarwood in Midland. Enjoy top-tier living and amenities at The Palms.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-midland-tx",
      "search_query": "one bedroom apartments in Midland TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Midland, TX",
      "h2_subtitle": "Explore one bedroom apartments in Midland, TX at The Palms at Briarwood. Perfectly designed for comfort and style.",
      "page_copy": "Discover the perfect blend of comfort and style in one bedroom apartments in Midland, TX at The Palms at Briarwood. Each unit is thoughtfully designed to maximize space and functionality while providing stylish interiors. Our one-bedroom layouts feature modern conveniences such as stainless steel appliances, granite breakfast bars, and walk-in closets, ensuring a seamless living experience.\n\nLocated in a vibrant Midland neighborhood, The Palms offers more than just a place to live. With access to community amenities like a business center, media room, and off-leash dog park, you'll find everything you need for a balanced lifestyle just steps away. Enjoy the peace of a smoke-free environment while taking advantage of ceiling fans and air conditioning to stay comfortable all year round. Welcome home to The Palms at Briarwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Midland, TX - The Palms",
      "seo_description": "Find beautifully designed one bedroom apartments in Midland, TX at The Palms, featuring modern amenities and stylish living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "two-bedroom-floor-plans-briarwood",
      "search_query": "two bedroom floor plans at Briarwood",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans at Briarwood",
      "h2_subtitle": "Discover spacious two bedroom floor plans at Briarwood in Midland. Elegant layouts perfect for comfort and functionality.",
      "page_copy": "Explore the spacious two-bedroom floor plans at Briarwood, designed for those who appreciate elegance and functionality. The Palms at Briarwood offers layouts tailored to provide ample living space, ideal for roommates, small families, or anyone who desires additional room. Each apartment comes equipped with modern features such as stainless steel appliances, granite breakfast bars, and generous walk-in closets.\n\nSet in the heart of Midland, The Palms at Briarwood invites you to enjoy a variety of community facilities that enhance your living experience. From the convenience of a business center to the enjoyment of a media room and a delightful off-leash dog park, life at Briarwood is both comfortable and enriching. Embrace the blend of luxury and practicality with our expertly designed two-bedroom floor plans.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans at Briarwood - The Palms",
      "seo_description": "Explore elegant and spacious two bedroom floor plans at Briarwood, Midland. Find comfort at The Palms with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-79707",
      "search_query": "three bedroom apartments near 79707",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 79707",
      "h2_subtitle": "Explore three bedroom apartments near 79707 at The Palms at Briarwood. Spacious living in a prime location.",
      "page_copy": "Discover the ideal living solution with three bedroom apartments near 79707 at The Palms at Briarwood. Perfect for families or those who desire extra space, our three-bedroom layouts provide an abundance of room paired with modern amenities. Each apartment features stainless steel appliances, granite breakfast bars, and generous walk-in closets to enhance your lifestyle.\n\nNestled in Midland, The Palms at Briarwood offers more than just a place to live. Enjoy community amenities including a business center, media room, and off-leash dog park—all designed to enrich your living experience. With spacious interiors and a convenient location near 79707, The Palms delivers both comfort and accessibility. Experience the perfect balance of style and practicality in your new three-bedroom home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 79707 - The Palms",
      "seo_description": "Find spacious three bedroom apartments near 79707 at The Palms. Enjoy modern features and convenient Midland location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "apartments-near-midland-college-tx",
      "search_query": "apartments near Midland College TX",
      "category": "School",
      "h1_title": "Apartments Near Midland College, TX",
      "h2_subtitle": "Discover premium apartments near Midland College, TX at The Palms at Briarwood. Convenient and stylish living awaits.",
      "page_copy": "Experience convenient living with apartments near Midland College, TX, at The Palms at Briarwood. Perfectly suited for students and professionals alike, our community offers a blend of comfort and style within proximity to the college campus. Choose from one, two, or three-bedroom layouts featuring modern amenities such as stainless steel appliances and walk-in closets.\n\nThe Palms at Briarwood presents a host of premium community amenities designed for an enriched lifestyle. From a dedicated business center and media room to an off-leash dog park, we cater to diverse needs and interests. Our smoke-free environment and stylish interiors make it an ideal choice for those who value both functionality and aesthetics. Enjoy the ease of living near Midland College while indulging in all that our community has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Midland College, TX - The Palms",
      "seo_description": "Live close to Midland College, TX at The Palms. Discover stylish apartments with modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "the-palms-apartments-close-to-ut-permian-basin",
      "search_query": "The Palms apartments close to UT Permian Basin",
      "category": "School",
      "h1_title": "The Palms Apartments Close to UT Permian Basin",
      "h2_subtitle": "Convenience meets style at The Palms apartments, located close to UT Permian Basin. Ideal for students and faculty.",
      "page_copy": "Enjoy living at The Palms apartments close to UT Permian Basin, where convenience complements contemporary living. Our community is perfect for students and faculty seeking comfortable accommodations with quick access to the university. Choose from thoughtfully designed one, two, or three-bedroom layouts, each featuring upscale elements like stainless steel appliances and granite breakfast bars.\n\nApart from our prime location, The Palms at Briarwood offers a variety of amenities to enhance your lifestyle. Relax in our media room, handle business in our fully-equipped center, or let your pets roam free in the off-leash dog park. Our smoke-free community ensures a clean and healthy environment, making The Palms an exceptional choice for those affiliated with UT Permian Basin. Discover the perfect blend of functionality and style just minutes away from campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Palms Apts Close to UT Permian Basin",
      "seo_description": "Find The Palms Apartments close to UT Permian Basin. Enjoy convenient living with modern amenities and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "odessa-college-nearby-apartments-midland",
      "search_query": "Odessa College nearby apartments Midland",
      "category": "School",
      "h1_title": "Odessa College Nearby Apartments in Midland",
      "h2_subtitle": "Find ideal apartments in Midland near Odessa College. Enjoy a convenient and vibrant lifestyle at The Palms at Briarwood.",
      "page_copy": "Discover Odessa College nearby apartments in Midland with The Palms at Briarwood, offering a perfect blend of comfort and accessibility. Situated just a short drive from Odessa College, our community is an excellent choice for students and staff who desire a modern living space close to their academic commitments. Choose from various floor plans, including one, two, or three-bedroom options, all featuring sleek stainless steel appliances and spacious walk-in closets.\n\nThe Palms at Briarwood is not just about convenient location—it’s about enhancing daily life. Enjoy our smoke-free environment with amenities such as a media room, business center, and an off-leash dog park. These features, coupled with our proximity to Odessa College, make The Palms the perfect choice for those who seek both quality and convenience in their next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Odessa College Apartments in Midland - The Palms",
      "seo_description": "Find apartments near Odessa College in Midland at The Palms. Enjoy modern amenities and a prime location perfect for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "carver-center-elementary-nearby-rentals",
      "search_query": "Carver Center elementary nearby rentals",
      "category": "School",
      "h1_title": "Rentals Near Carver Center Elementary",
      "h2_subtitle": "Explore family-friendly rentals near Carver Center Elementary at The Palms at Briarwood. A perfect community for families.",
      "page_copy": "Searching for the ideal rentals near Carver Center Elementary? Look no further than The Palms at Briarwood, offering convenient and comfortable living in Midland. Our community is ideal for families seeking a home close to quality education and exceptional amenities. Choose from a selection of one, two, or three-bedroom layouts, all designed with family needs in mind, featuring features like granite breakfast bars and spacious accommodation.\n\nThe Palms at Briarwood ensures a welcoming atmosphere for all ages. Parents will appreciate the community's supportive environment, which includes amenities like a business center, for work-from-home convenience, and a children's play area. The smoke-free surroundings and a friendly neighborhood ambiance make it an excellent choice for families. Enjoy peace of mind knowing that Carver Center Elementary is just a short trip away, making daily commutes effortless.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Carver Center Elementary - The Palms",
      "seo_description": "Find family-friendly rentals near Carver Center Elementary at The Palms. Spacious and modern homes ideal for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "greathouse-elementary-school-midland-apartments",
      "search_query": "Greathouse Elementary School Midland apartments",
      "category": "School",
      "h1_title": "Midland Apartments by Greathouse Elementary",
      "h2_subtitle": "Discover Midland apartments near Greathouse Elementary School. Ideal for families seeking convenience and comfort at The Palms at Briarwood.",
      "page_copy": "For families prioritizing education, The Palms at Briarwood offers perfect Midland apartments near Greathouse Elementary School. Our community provides a seamless blend of convenience and quality, ensuring you are close to esteemed educational institutions while enjoying exceptional living arrangements. Choose among our spacious one, two, and three-bedroom apartments, all equipped with modern amenities like stainless steel appliances and walk-in closets.\n\nAt The Palms at Briarwood, family life is made easier with our variety of amenities. Our smoke-free environment promotes health and wellness, while services like the business center support busy parents. The community is welcoming and child-friendly—perfect for those who appreciate proximity to Greathouse Elementary School while reveling in modern comforts. Make the move to The Palms and experience the perfect home base in Midland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midland Apartments Near Greathouse Elementary",
      "seo_description": "Explore The Palms at Briarwood for apartments near Greathouse Elementary in Midland. Spacious layouts and family-friendly amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "abell-junior-high-school-nearby-rentals",
      "search_query": "Abell Junior High School nearby rentals",
      "category": "School",
      "h1_title": "Rentals Near Abell Junior High School",
      "h2_subtitle": "Find the perfect rentals near Abell Junior High School at The Palms at Briarwood. A perfect location for growing families in Midland.",
      "page_copy": "Explore the ideal location of The Palms at Briarwood for families looking for rentals near Abell Junior High School. Our community offers proximity to quality education while providing a comfortable and stylish living environment. Choose from versatile one, two, and three-bedroom options that include modern amenities such as stainless steel appliances and spacious walk-in closets.\n\nThe Palms at Briarwood is a family-conscious community that supports both educational and lifestyle needs. Enjoy features like a business center, perfect for working parents, and a smoke-free atmosphere that ensures a healthy living environment. Located just a short distance from Abell Junior High School, our rentals make daily commutes easy and stress-free for students and parents alike, all while fostering a welcoming community spirit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals By Abell Junior High School - The Palms",
      "seo_description": "Discover The Palms at Briarwood for rentals near Abell Junior High School. Ideal for families seeking convenience and quality living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "apartments-near-midland-freshman-high-school-tx",
      "search_query": "apartments near Midland Freshman High School TX",
      "category": "School",
      "h1_title": "Find Apartments Near Midland Freshman High",
      "h2_subtitle": "Discover comfortable apartments near Midland Freshman High School in TX. The Palms at Briarwood offers a convenient location and modern amenities.",
      "page_copy": "If you're searching for apartments near Midland Freshman High School in TX, The Palms at Briarwood is the perfect choice. Our community offers convenient proximity to the school, making it an advantageous location for students and parents alike. At The Palms, you'll find a range of one, two, and three-bedroom apartments, each designed with modern living in mind. Enjoy features like stainless steel appliances that highlight the contemporary feel of our homes.\n\nThe Palms at Briarwood in Midland provides an exceptional environment for both education and recreation. Our amenities include a business center, ensuring parents can work efficiently, and a media room for relaxation and entertainment. With a smoke-free community and welcoming atmosphere, it's an ideal spot for families focused on educational priorities at Midland Freshman High School. Enjoy the peace of mind that comes with a convenient location and a vibrant resident community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Midland Freshman High School TX",
      "seo_description": "Explore The Palms at Briarwood, offering apartments near Midland Freshman High School in TX. Convenience and modern amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "early-college-high-school-midland-college-close-apartments",
      "search_query": "Early College High School Midland College close apartments",
      "category": "School",
      "h1_title": "Close Apartments to Early College High School",
      "h2_subtitle": "Explore close apartments to Early College High School at Midland College. The Palms at Briarwood offers convenient living with excellent amenities.",
      "page_copy": "Searching for close apartments to Early College High School at Midland College? Look no further than The Palms at Briarwood. Our community provides the perfect blend of proximity and comfort, ideal for students and families alike. Choose from our array of one, two, and three-bedroom layouts, each featuring modern touches like granite breakfast bars and ceiling fans that enhance your living experience.\n\nAt The Palms at Briarwood, enjoy seamless access to both educational and lifestyle amenities. Our smoke-free community is welcoming and supportive, boasting features like a surround sound media room and a well-equipped business center, perfect for both study and relaxation. With easy access to Early College High School and Midland College, our location makes it simple for students and faculty to commute with ease while enjoying a vibrant living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments to Early College High School",
      "seo_description": "Find The Palms at Briarwood for close apartments to Early College High School at Midland College. Enjoy modern comforts and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "lee-high-school-midland-tx-affordable-apartments",
      "search_query": "Lee High School Midland TX affordable apartments",
      "category": "School",
      "h1_title": "Affordable Apartments Near Lee High School",
      "h2_subtitle": "Discover affordable apartments near Lee High School in Midland, TX. The Palms at Briarwood offers great value with stylish living.",
      "page_copy": "Looking for affordable apartments near Lee High School in Midland, TX? The Palms at Briarwood offers a unique blend of cost-effectiveness and modern amenities, perfect for families and students. Select from our selection of one, two, and three-bedroom apartments, each thoughtfully designed with stainless steel appliances and ceiling fans for ultimate comfort.\n\nAt The Palms at Briarwood, affordability meets lifestyle. Enjoy community features such as a business center for working professionals and a welcoming off-leash dog park. Our smoke-free environment not only prioritizes health but also ensures a refined living experience. With its convenient location near Lee High School, The Palms provides easy access to quality education and a supportive community for all its residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Affordable Apartments Near Lee High School",
      "seo_description": "Find affordable living at The Palms, near Lee High School in Midland, TX. Stylish and cost-effective apartments with exceptional amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5175251218464768",
      "source": "generator",
      "page_item_url": "trinity-school-midland-close-apartments",
      "search_query": "Trinity School Midland close apartments",
      "category": "School",
      "h1_title": "Close Apartments to Trinity School in Midland",
      "h2_subtitle": "Discover apartments close to Trinity School in Midland. The Palms at Briarwood offers exceptional living with modern amenities and convenience.",
      "page_copy": "For those seeking close apartments to Trinity School in Midland, The Palms at Briarwood presents an ideal choice. Our community combines convenience and contemporary design, perfect for families and students. Choose from our selection of one, two, and three-bedroom apartments, each equipped with premium features like walk-in closets and granite breakfast bars.\n\nSituated near Trinity School, The Palms at Briarwood ensures easy access to educational facilities and city amenities. Residents can enjoy a smoke-free environment, a well-furnished media room for leisure, and a business center for work-related needs. With ceiling fans and stainless steel appliances complementing each unit, our community offers both comfort and practicality to streamline your living experience in Midland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d019c-ba6a-75a9-9afe-b42a3319123b",
        "storage_key": "property/5175251218464768/019d019c-ba6a-75a9-9afe-b42a3319123b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments to Trinity School Midland",
      "seo_description": "Explore The Palms at Briarwood, offering close proximity to Trinity School in Midland. Enjoy modern living and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4748"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445191"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4322183244"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-P53WHM4V"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 5"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "2b282042-e721-4cae-a950-35f57449046b"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/6f7e4695-a90f-4c52-80cd-6027ae7d4e51/app.js?property=6f7e4695-a90f-4c52-80cd-6027ae7d4e51&propertyName=The+Palms+at+Briarwood&channelUuid=c248f92d-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlVWOEdpd0J1YTlyRDVQMFF0VGVRSUE9PSIsInZhbHVlIjoiUFhXdGdOOEo3S1cwV2ZzRDIzN1hmZz09IiwibWFjIjoiOGNhMmNiNWFmODA4NDAwM2ZmOTdhZWI2NDRlNzMzNjAwYTcxZjU0NDhhMDIyOTQxNTBjOTdlODMyZGEzNGZjYiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4748",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445191",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4322183244",
  "custom_google_gtm_id": "\tGTM-P53WHM4V",
  "custom_rollout_phase": "Phase 5",
  "custom_rentgrata_token": "2b282042-e721-4cae-a950-35f57449046b",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/6f7e4695-a90f-4c52-80cd-6027ae7d4e51/app.js?property=6f7e4695-a90f-4c52-80cd-6027ae7d4e51&propertyName=The+Palms+at+Briarwood&channelUuid=c248f92d-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlVWOEdpd0J1YTlyRDVQMFF0VGVRSUE9PSIsInZhbHVlIjoiUFhXdGdOOEo3S1cwV2ZzRDIzN1hmZz09IiwibWFjIjoiOGNhMmNiNWFmODA4NDAwM2ZmOTdhZWI2NDRlNzMzNjAwYTcxZjU0NDhhMDIyOTQxNTBjOTdlODMyZGEzNGZjYiJ9",
  "custom_audioeye_site_id": "482a2f1d-90e0-45bf-a30d-25f585d9fff9",
  "custom_audioeye_site_hash": "673dd98f68f036a174e3eadebe5aded2"
};

export const generatedAt = '2026-10-27T17:07:34.420Z';
